import React, { useState } from "react";

import { useGetPracticeCrops, useMutateFootprintingCropCreateManyBlankPrimaryData, useTranslation } from "utils";

import { Button, Flex, SelectableImageCard } from "components";

export const AssessmentSelectionScreen = ({ year, farmId, programCrops }: { year: number; farmId: string; programCrops?: string[] }) => {
  const { t } = useTranslation("footprinting");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedCommodities, setSelectedCommodities] = useState<Record<string, boolean>>({});
  const { data: allCrops } = useGetPracticeCrops({ enabled: true });
  const { mutate: createBlankPrimaryDataRows } = useMutateFootprintingCropCreateManyBlankPrimaryData(farmId, programCrops ?? [], year);

  if (!programCrops) return null;

  const onClickDone = () => {
    setIsLoading(true);
    createBlankPrimaryDataRows(
      Object.entries(selectedCommodities)
        .filter(([_, isSelected]) => isSelected)
        .map(([cropId]) => cropId)
    );
  };

  return (
    <Flex className="assessment-selection" vertical align="center" gap={0}>
      <Flex className="assessment-selection-text" vertical gap={0} align="center">
        <p className="grey-600-text margin-0">{t("assessmentSelection.callout")}</p>
        <h3>{t("assessmentSelection.title")}</h3>
      </Flex>
      {programCrops.map((cropId) => {
        const cropInfo = allCrops?.find((c) => c.id === cropId);
        if (!cropInfo) return null;

        return (
          <SelectableImageCard
            key={cropInfo.id}
            selectionMode="multiple"
            title={cropInfo.name}
            checked={selectedCommodities[cropId]}
            onChange={() => setSelectedCommodities({ ...selectedCommodities, [cropId]: !selectedCommodities[cropId] })}
            image={{
              imageAlt: `${cropInfo.name} image`,
              imageSrc: cropInfo.imageURL ?? "",
            }}
          />
        );
      })}
      <Button
        className="assessment-selection-next-button"
        type="primary"
        disabled={isLoading || Object.values(selectedCommodities).filter(Boolean).length === 0}
        onClick={onClickDone}
      >
        {t("assessmentSelection.nextButton")}
      </Button>
    </Flex>
  );
};
